import React from 'react'

import { ColorContext } from './color.context'

interface ColorProviderProps {
  children: React.ReactNode
  colour: {
    colour: { hex: string | null } | null
    isLight: boolean | null
  } | null
}

export const ColorProvider: React.FC<ColorProviderProps> = ({
  children,
  colour
}) => <ColorContext.Provider value={colour}>{children}</ColorContext.Provider>
